import React from "react";

const AllReceipts = () => {
  return <div>AllReceipts</div>;
};

export default AllReceipts;
